import React from "react";

const FullScreenLoader = () => {
  return (
    <div className="loader-container">
      <div className="loader"></div>
    </div>
  );
};

export default FullScreenLoader;
